import Helper from '@/Helper'
export default {
  getListDocumentItem (state, payload) {
    state.document_items = Helper.recursiveDocItem(payload, 0)
  },
  setDocumentQueue (state, payload) {
    state.document_queue.push(payload)
  },
  removeDocumentQueue (state, payload) {
    var index = state.document_queue.indexOf(payload)
    state.document_queue.splice(index, 1)
  },
  updateDocumentItem (state, payload) {
    var data = []
    var items = []
    state.document_items.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.forEach(element => {
      if (parseInt(element.id) === parseInt(payload.id)) {
        element = payload
      }
      items.push(element)
    })
    state.document_items = Helper.getNestedChildren(items, 0)
  },
  destroyDocumentItem (state, payload) {
    var data = []
    var items = []
    state.document_items.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.forEach(element => {
      if (parseInt(element.id) === parseInt(payload.id)) {
      } else {
        items.push(element)
      }
    })
    state.document_items = Helper.getNestedChildren(items, 0)
  },
  createDocumentItem (state, payload) {
    var data = []
    state.document_items.forEach(element => {
      data = data.concat(Helper.getUnNestedChildren(element))
    })
    data.push(payload)
    state.document_items = Helper.getNestedChildren(data, 0)
  }
  // nodeDocumentItem (state, payload){

  // }
}



// WEBPACK FOOTER //
// ./src/store/module/document-item/mutations.js